import React from 'react';

export interface TableHeadContextProps {
  isHead: boolean;
  textAlign?: string;
  color?: string;
  background?: string;
}

const TableHeadContext = React.createContext<TableHeadContextProps>({ isHead: false });

export default TableHeadContext;
